module.exports = __webpack_public_path__ + "static/media/delete.a868c1c7.svg";